module.exports = __webpack_public_path__ + "c9173f4133ea30a515a3766f0168dd80.png";